module.exports = __webpack_public_path__ + "media/images/payments/payoneer-dark-7c5207e424f173999b3d40936d23cb24.svg";